import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { first } from 'rxjs/operators';

import { MotesLoginService } from '../../motes-login';
import { ProductService, VoucherService } from '../../providers';
import { Challenge, ChallengeState, DatabaseModel, ModelMap, Product, Voucher } from '../../models';

@Component({
    selector: 'quiz-reward-list',
    templateUrl: './quiz-reward-list.component.html',
    styleUrls: ['./quiz-reward-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuizRewardListComponent implements OnInit {
    /**
     * Challenge to get reward list from
     */
    @Input('challenge') set setChallenge(challenge: Challenge) {
        this.challenge = challenge;
        this.determineReward(challenge, this.challengeState);
    }

    /**
     * Challenge to get reward list from
     */
    @Input('challengeState') set setChallengeState(challengeState: ChallengeState) {
        this.challengeState = challengeState;
        this.determineReward(this.challenge, challengeState);
    }

    /**
     * Emit user reward when reward button is clicked
     */
    @Output() voucherClaimed = new EventEmitter<Voucher>();

    public challenge: Challenge;
    public challengeState: ChallengeState;
    public productMap: ModelMap<Product>

    // Reward list to be show in last quest quiz
    public rewardList: { product: Product, pointGoal: number, isHighestReward: boolean }[] = [];
    public reward: Product = null;

    public isClaimingVoucher: boolean = false;

    constructor(private productService: ProductService, private voucherService: VoucherService, private loginService: MotesLoginService) { }

    ngOnInit(): void {
    }

    private async getProductMap(challenge: Challenge): Promise<ModelMap<Product>> {
        let products = await this.productService.watchAllProducts(challenge.project).pipe(first()).toPromise();
        return DatabaseModel.arrayToMap(products);
    }

    /**
     * Determine the reward based on users total points in challenge and reward list point goals
     */
    private async determineReward(challenge: Challenge, challengeState: ChallengeState) {
        if(!challenge || !challengeState) return;
        this.productMap = await this.getProductMap(challenge);
        // Sort reward list by point goal 
        challenge.rewardList.sort((a, b) => a.pointGoal - b.pointGoal);
        // Loop through reward list and determine which reward should be given to user
        let canGetList = challenge.rewardList.map(reward => (reward.pointGoal <= this.challengeState.points)).filter(canGet => canGet);
        // Find the max idx user can get
        let canGetMaxIdx = canGetList.length - 1;
        // Generate reward list with product, point goal and highest reward  
        this.rewardList = challenge.rewardList.map((reward, idx) => {
            return { product: this.productMap[reward.key], pointGoal: reward.pointGoal, isHighestReward: idx == canGetMaxIdx }
        });
        // Find highest reward
        this.reward = (canGetMaxIdx >= 0) ? this.rewardList[canGetMaxIdx].product : null;
    }

    public async emitRewardClaimed() {
        this.isClaimingVoucher = true;

        let user = await this.loginService.getCurrentUser();
        if(!user) {
            console.warn("Invalid user or no user, claim aborted", user);
        }

        let voucher = await this.voucherService.claimReward(this.challenge, user.uid, user.email, this.challengeState.getTotalPoints(), this.reward);
        if(!voucher) return console.error("Could not claim reward, database error?");
        this.voucherClaimed.emit(voucher);
    }
}
